module.exports = __webpack_public_path__ + "static/img/rrrr_25.7dfd711.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_25.png
// module id = iz1y
// module chunks = 1